import {
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Link as MuiLink,
  Typography,
} from "@mui/material";
import { breadcrumbsClasses } from "@mui/material/Breadcrumbs";
import { styled } from "@mui/material/styles";
import { useTemplate } from "containers/templateDetail/store";
import Link from "next/link";
import * as React from "react";

const Breadcrumbs = styled(MuiBreadcrumbs)(({ theme }) => ({
  [`& ${breadcrumbsClasses.separator}`]: {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary,
  },
}));

export default function TemplateDetail(): React.ReactElement {
  const { category, title: templateTitle } = useTemplate();
  // const categories = useSelector((store: RootState) => store.app.catalog);

  return (
    <Box sx={{ my: 2 }}>
      <Breadcrumbs aria-label="breadcrumb">
        <Link href="/custom/all" passHref>
          <MuiLink underline="always" color="textPrimary">
            Products
          </MuiLink>
        </Link>
        {category && (
          <Link href={`/custom/${category.key}`} passHref>
            <MuiLink underline="always" color="textPrimary">
              {category.name}
            </MuiLink>
          </Link>
        )}
        <Typography color="inherit">{templateTitle}</Typography>
      </Breadcrumbs>
    </Box>
  );
}
